import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@saucelabs/sl-component-buttons';
import { Modal } from '@saucelabs/sl-component-overlay';
import modalConnect from '@saucelabs/sl-container-modal';
import { ControlLabel, FormGroup, FormControl } from '@saucelabs/sl-component-form';

const MOBILE_PASTE_CONTENT_MODAL_KEY = 'pasteContentModal';

class PasteContentModal extends Component {
  handleConfirm = () => {
    const { onConfirm, onHide } = this.props;

    onConfirm(this.input.value).then(() => {
      onHide();
      this.input.value = '';
    });
  }

  render() {
    const { onHide, show } = this.props;

    return (
      <Modal
        onHide={onHide}
        show={show}
      >
        <Modal.Header>
          <Modal.Title>Paste Content Into Device</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {`Tip: Alternatively, use the keyboard shortcut Cmd + V
            directly on the device screen.`}
          </p>
          <FormGroup>
            <ControlLabel>Content</ControlLabel>
            <FormControl
              bsSize="large"
              componentClass="textarea"
              inputRef={(input) => {
                this.input = input;
              }}
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button
            category="default"
            material
            onClick={onHide}
            size="sm"
          >
            Cancel
          </Button>
          <Button
            category="action"
            material
            onClick={this.handleConfirm}
            raised
            size="sm"
          >
            Paste
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

PasteContentModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default modalConnect(MOBILE_PASTE_CONTENT_MODAL_KEY, PasteContentModal);
export {
  MOBILE_PASTE_CONTENT_MODAL_KEY,
  PasteContentModal,
};
